module.exports = __webpack_public_path__ + "static/img/microphone.b97456b1.gif";